import { apiClient } from './apiClient';
import {
  Zone,
  ZoneFormData,
  ZoneListParams,
  ZoneListResponse,
  ZoneResponse,
  ZonesListResponse,
} from '../types/zone';

class ZoneService {
  /**
   * Get paginated list of zones
   */
  async getZones(params: ZoneListParams = {}): Promise<ZoneListResponse> {
    const { data } = await apiClient.get('/zones', { params });
    return data;
  }

  /**
   * Get simple list of zones (for dropdowns)
   */
  async getZonesList(): Promise<Zone[]> {
    const { data } = await apiClient.get<ZonesListResponse>('/zones/list');
    return data.data;
  }

  /**
   * Get zone by ID
   */
  async getZoneById(id: string): Promise<Zone> {
    const { data } = await apiClient.get<ZoneResponse>(`/zones/${id}`);
    return data.data.zone;
  }

  /**
   * Create new zone
   */
  async createZone(zoneData: ZoneFormData): Promise<Zone> {
    const { data } = await apiClient.post<ZoneResponse>('/zones', zoneData);
    return data.data.zone;
  }

  /**
   * Update zone
   */
  async updateZone(id: string, zoneData: Partial<ZoneFormData>): Promise<Zone> {
    const { data } = await apiClient.put<ZoneResponse>(`/zones/${id}`, zoneData);
    return data.data.zone;
  }

  /**
   * Toggle zone visibility
   */
  async toggleVisibility(id: string, is_visible: boolean): Promise<Zone> {
    const { data } = await apiClient.patch<ZoneResponse>(`/zones/${id}/visibility`, { is_visible });
    return data.data.zone;
  }

  /**
   * Delete zone
   */
  async deleteZone(id: string): Promise<void> {
    await apiClient.delete(`/zones/${id}`);
  }

  /**
   * Restore deleted zone
   */
  async restoreZone(id: string): Promise<Zone> {
    const response = await apiClient.post<ZoneResponse>(`/zones/${id}/restore`);
    return response.data.data.zone;
  }
}

export default new ZoneService();

